import { IROIResult } from '../../hooks/jobPreferencesDataHook/useJobPreferencesDataHook';

export enum MixpanelEventsEnum {
  ADD_SKILL = 'Add Skill',
  DELETE_SKILL = 'Delete Skill',
  MODIFY_SKILL = 'Modify Skill',
  EXPLORE_SKILL_MODAL = 'Explore Skill Modal',
  EXPLORE_SKILL_SCREEN = 'Explore Skill Screen',
  ADD_OCCUPATION = 'Add Occupation',
  COMPLETED_PERSONAL_INFORMATION_STEP = 'Completed Personal Information Step',
  ADD_MAJOR = 'Add Major',
  COMPLETED_OCCUPATIONS_PREFERENCES_STEP = 'Completed Occupations Preferences Step',
  DELETE_MAJOR = 'Delete Major',
  COMPLETED_SKILLS_STEP = 'Completed Skills Step',
  UPLOAD_CV = 'Upload CV',
  REPLACE_CV = 'Replace CV',
  HELP_US_IMPROVE = 'Help us improve',
  VIEW_NOTIFICATIONS = 'View Notifications',
  CLEAR_NOTIFICATIONS = 'Clear Notifications',
  PROFILE_POPOVER = 'Profile Popover',
  GO_TO_PROFILE = 'Go to Profile',
  CHANGE_PASSWORD = 'Change Password',
  LOGOUT = 'Logout',
  EDIT_PERSONAL_INFO = 'Edit Personal Info',
  UPDATE_PERSONAL_INFO = 'Update Personal Info',
  PROFILE_UPDATED_SKILLS = 'Profile Updated Skills',
  PROFILE_UPDATED_PREFERENCES = 'Profile Updated Preferences',
  VIEW_MORE = 'View More',
  SKILL_TRACKER_FILTER = 'Skill Tracker Filter',
  OPTIONS_KANBAN_SKILL = 'Options Kanban Skill',
  EXPAND_PROFICIENCY_LEVELS = 'Expand Proficiency Levels',
  MOVE_ROULETTE = 'Move Roulette',
  TAB_EVENT = 'Tab Event',
  FAQ_QUESTION = 'FAQ Question',
  VIEW_PRIVACY_POLICY = 'View Privacy Policy',
  VIEW_TERMS_OF_SERVICE = 'View Terms of Service',
  SIGN_UP = 'Sign up',
  LOG_IN = 'Log in',
  RESET_PASSWORD = 'Reset Password',
  FORGOT_PASSWORD = 'Forgot Password',
  CLICK_HERE_SIGN_UP_CODE = 'Click here signup code',
  VERIFY_CODE = 'Verify Code',
  PRIVACY_POLICY_MODAL_OPEN = 'Privacy Policy Modal Open',
  ACCEPT_PRIVACY_POLICY = 'Accept Privacy Policy',
  DECLINE_PRIVACY_POLICY = 'Decline Privacy Policy',
  BROWSE_MORE_COURSES = 'Browse More Courses',
  FILTER_COURSES_PROVIDERS = 'Filter Course Provider',
  DELETE_OCCUPATION = 'Delete Occupation',
  EXPLORE_OCCUPATION_MODAL = 'Explore Occupation Modal',
  EXPLORE_OCCUPATION_SCREEN = 'Explore Occupation Screen',
  CLICK_COURSE = 'Click Course',
  CLICK_PROVIDER = 'Click Provider',
  SCREEN_TIME = 'Screen Time',
  WIZARD_COMPLETED = 'Wizard Completed',
  MAJOR_FILTER_SUGGESTIONS = 'Major Filter Suggestions',
  SELECT_SKILL_INSIGHTS_SCREEN = 'Select Skill Insights Screen',
  EXPLORE_OCCUPATION_OVERVIEW_MODAL = 'Explore Occupation Overview Modal',
  CARD_TOP_SKILL_SCROLL = 'Card Top Skill Scroll',
  SEARCH_BY_STUDENT_NAME = 'Search By Student Name',
  ADVISOR_PROFILE_POPOVER = 'Advisor Profile Popover',
  ADD_HOBBY = 'Add Hobby',
  IKIGAI_HOME = 'Ikigai Home',
  IKIGAI_STEP_PASSION = 'Ikigai Step Passion',
  IKIGAI_STEP_MISSION = 'Ikigai Step Mission',
  IKIGAI_STEP_PROFESSION = 'Ikigai Step Profession',
  IKIGAI_STEP_VOCATION = 'Ikigai Step Vocation',
  IKIGAI_RECOMMENDATIONS = 'Ikigai Recommendations',
  LEARNING_RESOURCES_INTERESTED = 'Learning Resources Interested',
  LEARNING_RESOURCES_NOT_INTERESTED = 'Learning Resources Not Interested',
  INTERESTED_COURSE = 'Interested Course',
  ADVISOR_NOTIFICATION = 'Advisor Notification',
  VIEW_RELEVANT_SKILLS = 'View Relevant Skills',
  VIEW_JOB_POSTING = 'View Job Posting',
  APPLY_FILTER = 'Apply Filter',
  EXPORT_STUDENT_OVERVIEW_CSV = 'Export Student Overview CSV',
  NO_SPONSORED_COURSES = 'No Sponsored Courses',
  EXPAND_ACCORDION_PROFICIENCY_LEVELS = 'Expand Accordion Proficiency Levels',
  SELECT_PROFICIENCY_LEVEL = 'Select Proficiency Level',
  PROFICIENCY_TAB_SELECTED = 'Proficiency Tab selected',
  VIEW_LEARNING_PATH = 'View Learning Path',
  BOOKMARK_CLICK = 'Bookmark Click',
  SELECT_COLLECTION = 'Select Collection',
  CREATE_COLLECTION = 'Create Collection',
  DELETE_COLLECTION = 'Delete Collection',
  MODIFY_COLLECTION_NAME = 'Modify Collection Name',
  DELETE_COURSE_FROM_COLLECTION = 'Delete Course From Collection',
  EMPTY_STATE_ADD_COURSES_TAPPED = 'Empty State Add Courses Tapped',
  SAVE_COURSE_ICON_TAPPED = 'Save course Icon Tapped',
  COURSE_SAVED = 'Course Saved',
  TOAST_CTA_COURSES_TAPPED = 'Toast CTA Courses Tapped',
  REMOVE_SAVED_COURSE = 'Remove saved course',
  VIEW_LEARNING_RESOURCE_ROI_SECTION = 'View Learning Resource ROI Section',
  EXPAND_LEARNING_RESOURCE_ROI = 'Expand Learning Resource ROI',
  COLLAPSE_LEARNING_RESOURCE_ROI = 'Collapse Learning Resource ROI',
  VIEW_LEARNING_RESOURCE_ROI_CARD = 'View Learning Resource ROI Card',
  OPEN_ADD_EXPERIENCE = 'Open Add Experience',
  EDIT_EXPERIENCE = 'Edit Experience',
  DELETE_EXPERIENCE = 'Delete Experience',
  ADD_EXPERIECNCE = 'Add Experience',
  OPEN_EDIT_EXPERIENCE = 'Open Edit Experience',
  EXTRACT_EXPERIENCE_SKILLS = 'Experience Skills Extracted',
  REQUEST_CONTACT_LP_PLAR = 'Request Contact LP PLAR',
  VIEW_SALARY_TRENDS = 'View Salary Trends',
  VIEW_SALARY_TRENDS_EMPTY = 'View Salary Trends Empty',
  VIEW_JOB_OUTLOOK_SALARY = 'View Job Outlook Salary',
  VIEW_JOB_OUTLOOK_SALARY_EMPTY = 'View Job Outlook Salary Empty',
  CLICK_JOB_OUTLOOK_AI_IMPACT_INTEREST = 'Click Job Outlook AI Impact Interest',
  CLICK_JOB_OUTLOOK_GLOBAL_DEMAND_INTEREST = 'Click Job Outlook Global Demand Interest',
  LOGIN_ERROR = 'Login Error',
  SIGNUP_ERROR = 'Signup Error',
  LOGIN_ATTEMPT = 'Login Attempt',
  SSO_INITIATED = 'SSO Initiated',
  WIZARD_STARTED = 'Wizard Started',
  WIZARD_BACK = 'Wizard Back',
  CV_SKILLS_DETECTED = 'CV Skills Detected',
  ALUMNI_INSIGHTS_BLUE_BOX_VIEWED = 'Alumni Insights Blue Box Viewed',
  ALUMNI_INSIGHTS_BLUE_BOX_CLICKED = 'Alumni Insights Blue Box Clicked',
  ALUMNI_INSIGHTS_MODAL_OPENED = 'Alumni Insights Modal Opened',
  ALUMNI_INSIGHTS_MODAL_CLOSED = 'Alumni Insights Modal Closed',
  ALUMNI_INSIGHTS_INTEREST_CONFIRMED = 'Alumni Insights Interest Confirmed',
  ALUMNI_INSIGHTS_REQUEST_SUCCESS = 'Alumni Insights Request Success',
  ALUMNI_INSIGHTS_REQUEST_FAILED = 'Alumni Insights Request Failed',
  CUSTOMIZE_OCCUPATION_LIST_BUTTON_CLICKED = 'Customize Occupation List Button Clicked',
  CURRICULAR_ANALYTICS_MODAL_OPENED = 'Curricular Analytics Modal Opened',
  CURRICULAR_ANALYTICS_MODAL_CLOSED = 'Curricular Analytics Modal Closed',
  CURRICULAR_ANALYTICS_INTEREST_CONFIRMED = 'Curricular Analytics Interest Confirmed',
  CURRICULAR_ANALYTICS_REQUEST_SUCCESS = 'Curricular Analytics Request Success',
  CURRICULAR_ANALYTICS_REQUEST_FAILED = 'Curricular Analytics Request Failed',
  ENTER_OCCUPATION_COMPARISON = 'Enter Occupation Comparison',
  SELECT_OCCUPATION_COMPARISON_FILTER = 'Select Occupation Comparison Filter',
  TOGGLE_OCCUPATION_IN_COMPARISON = 'Toggle Occupation In Comparison',
  CLICK_DESIGN_PATH = 'Click Design Path',
  OPENED_PATH_CREATION_STEP = 'Opened path creation step',
  FINISHED_PATH_CREATION = 'Finished Path Creation',
  OCCUPATION_SUGGESTED_TAPPED = 'Occupation Suggested Tapped',
  CLICK_CAREER_FINDER_QUIZ = 'Click Career Finder Quiz',
  ADD_CAREER_FIELD_CTA = 'Add Career Field CTA',
  OCCUPATION_MODAL_LIMIT_VIEWED = 'Occupation Modal Limit Viewed',
  OCCUPATION_REPLACED = 'Occupation Replaced',
  CLICK_JOBPOSTING_RECOMMENDATIONS_OUTLOOK = 'Click JobPosting Recommendations Outlook',
  LEARNING_PATH_SEARCH_PERFORMED = 'Learning Path Search Performed',
  SEARCH_RESULT_ITEM_TAPPED = 'Search Result Item Tapped',
  LP_CAREER_MATCH_ACCORDION_EXPANDED = 'LP Career Match Accordion Expanded',
  OCCUPATION_MATCH_DETAIL_EXPANDED = 'Occupation Match Detail Expanded',
  ADD_TO_MY_PATHS = 'Add to my paths',
  VIEW_ALL_SKILLS_TAPPED = 'View All Skills Tapped',
}

// Generic Props (generic props apply to all events)
interface IGenericPropsForEvents {
  screen: string;
  component?: string;
  action?: string;
}

// #region PROFICIENCY LEVELS EVENTS

interface IGenericProficiencyLevelsEvent extends IGenericPropsForEvents {
  proficiencyLevelClicked: number;
}

interface IExpandAccordionProficiencyLevelsData extends IGenericProficiencyLevelsEvent {
  currentProficiencyLevel: number | null;
  skillName: string;
  skillType: string;
  skillStatus: string | null;
}

interface IExpandAccordionProficiencyLevelsEvent {
  action: MixpanelEventsEnum.EXPAND_ACCORDION_PROFICIENCY_LEVELS;
  data: IExpandAccordionProficiencyLevelsData;
}

interface ISelectProficiencyLevelData extends IGenericProficiencyLevelsEvent {
  skillName: string;
  skillType: string;
  skillStatus: string | null;
  currentProficiencyLevel: number | null;
  deselectedProficiencyLevel?: boolean;
}

interface ISelectProficiencyLevelEvent {
  action: MixpanelEventsEnum.SELECT_PROFICIENCY_LEVEL;
  data: ISelectProficiencyLevelData;
}

interface IProficiencyTabSelectedData extends IGenericPropsForEvents {
  proficiencyClicked: string;
}

interface IProficiencyTabSelectedEvent {
  action: MixpanelEventsEnum.PROFICIENCY_TAB_SELECTED;
  data: IProficiencyTabSelectedData;
}
// #endregion

// #region LEARNING PATHS EVENTS

type ViewLearningPathType = 'career field recommended' | 'occupation objective recommended' | 'your paths';

interface IViewLearningPathEventData extends IGenericPropsForEvents {
  learningPathName: string;
  providerId: string;
  type: ViewLearningPathType;
  coursesNumber: number;
  completed?: boolean;
  occupationName?: string;
}

interface IViewLearningPathEvent {
  action: MixpanelEventsEnum.VIEW_LEARNING_PATH;
  data: IViewLearningPathEventData;
}

interface ILearningPathSearchPerformedEventData extends IGenericPropsForEvents {
  searchQuery: string;
}

interface ILearningPathSearchPerformedEvent {
  action: MixpanelEventsEnum.LEARNING_PATH_SEARCH_PERFORMED;
  data: ILearningPathSearchPerformedEventData;
}

type SearchResultItemType = 'learningPath' | 'Course';

interface ISearchResultItemTappedEventData extends IGenericPropsForEvents {
  itemType: SearchResultItemType;
  itemName: string;
}

interface ISearchResultItemTappedEvent {
  action: MixpanelEventsEnum.SEARCH_RESULT_ITEM_TAPPED;
  data: ISearchResultItemTappedEventData;
}

interface ILPCareerMatchAccordionExpandedEventData extends IGenericPropsForEvents {
  learningPathName: string;
}

interface ILPCareerMatchAccordionExpandedEvent {
  action: MixpanelEventsEnum.LP_CAREER_MATCH_ACCORDION_EXPANDED;
  data: ILPCareerMatchAccordionExpandedEventData;
}

interface IOccupationMatchDetailExpandedEventData extends IGenericPropsForEvents {
  occupationName: string;
  learningPathName: string;
}

interface IOccupationMatchDetailExpandedEvent {
  action: MixpanelEventsEnum.OCCUPATION_MATCH_DETAIL_EXPANDED;
  data: IOccupationMatchDetailExpandedEventData;
}

interface IAddToMyPathsEventData extends IGenericPropsForEvents {
  learningPathName: string;
  coursesCount: number;
  provider: string;
}

interface IAddToMyPathsEvent {
  action: MixpanelEventsEnum.ADD_TO_MY_PATHS;
  data: IAddToMyPathsEventData;
}

type ViewAllSkillsTappedSource = 'Course card' | 'Path header';

interface IViewAllSkillsTappedEventData extends IGenericPropsForEvents {
  source: ViewAllSkillsTappedSource;
  learningPathName?: string;
  courseName?: string;
}

interface IViewAllSkillsTappedEvent {
  action: MixpanelEventsEnum.VIEW_ALL_SKILLS_TAPPED;
  data: IViewAllSkillsTappedEventData;
}

// #endregion

// #region SKILL EVENTS
interface IGenericSkillEvent extends IGenericPropsForEvents {
  skillName: string;
  skillStatus: string;
  skillType: string;
}

interface IAddSkillEventData extends IGenericSkillEvent {
  recommended: boolean;
}

interface IAddSkillEvent {
  action: MixpanelEventsEnum.ADD_SKILL;
  data: IAddSkillEventData;
}

interface IDeleteSkillEvent {
  action: MixpanelEventsEnum.DELETE_SKILL;
  data: IGenericSkillEvent;
}

interface IModifySkillEventData extends IGenericSkillEvent {
  fromStatus: string;
}

interface IModifySkillEvent {
  action: MixpanelEventsEnum.MODIFY_SKILL;
  data: IModifySkillEventData;
}

interface IExploreSkillModalData extends IGenericPropsForEvents {
  skillName: string;
  skillType: string;
  skillStatus?: string;
  recommended?: boolean;
}

interface IExploreSkillModalEvent {
  action: MixpanelEventsEnum.EXPLORE_SKILL_MODAL;
  data: IExploreSkillModalData;
}

interface IExploreSkillEventData extends IGenericPropsForEvents {
  recommended: boolean;
  skillName: string;
}

interface IExploreSkillScreenEvent {
  action: MixpanelEventsEnum.EXPLORE_SKILL_SCREEN;
  data: IExploreSkillEventData;
}
// #endregion

// #region OCCUPATION EVENTS

interface ILearningResourcesInterestedEventData extends IGenericPropsForEvents {
  jobTitleName: string;
  clickedBy: string;
  isInterested: boolean;
}

interface ILearningResourcesInterestedEvent {
  action: MixpanelEventsEnum.LEARNING_RESOURCES_INTERESTED;
  data: ILearningResourcesInterestedEventData;
}

interface ILearningResourcesNotInterestedEvent {
  action: MixpanelEventsEnum.LEARNING_RESOURCES_NOT_INTERESTED;
  data: ILearningResourcesInterestedEventData;
}

interface IGenericOccupationEvent extends IGenericPropsForEvents {
  occupationName: string;
}
interface IDataAddOccupationEvent extends IGenericOccupationEvent {
  replaceAnOccupation: string;
  recommendedBy: string;
}
interface IDataExploreOccupationModalEvent extends IGenericOccupationEvent {
  percentageOfMatch: string | number;
  recommendedBy: string;
}
interface IAddOccupationEvent {
  action: MixpanelEventsEnum.ADD_OCCUPATION;
  data: IDataAddOccupationEvent;
}

interface IDeleteOccupationEvent {
  action: MixpanelEventsEnum.DELETE_OCCUPATION;
  data: IGenericOccupationEvent;
}

interface IExploreOccupationModalEvent {
  action: MixpanelEventsEnum.EXPLORE_OCCUPATION_MODAL;
  data: IDataExploreOccupationModalEvent;
}
interface IExploreOccupationScreen {
  action: MixpanelEventsEnum.EXPLORE_OCCUPATION_SCREEN;
  data: IGenericOccupationEvent;
}
// #endregion

// #region COURSES EVENTS
interface IGenericCourseEvent extends IGenericPropsForEvents {
  courseProvider?: string;
}

interface IBrowseMoreCoursesEvent {
  action: MixpanelEventsEnum.BROWSE_MORE_COURSES;
  data: IGenericCourseEvent;
}

interface IFilterCourseProvider {
  action: MixpanelEventsEnum.FILTER_COURSES_PROVIDERS;
  data: IGenericCourseEvent;
}

interface IDataGenericCourseEvent extends IGenericCourseEvent {
  skillName?: string;
  courseName?: string;
  courseProvider?: string;
  isSponsored?: boolean;
  institutionName?: string;
}

interface IClickCourseEvent {
  action: MixpanelEventsEnum.CLICK_COURSE;
  data: IDataGenericCourseEvent;
}

interface IDataInterestedCourseEvent extends IGenericCourseEvent {
  skillName?: string;
  courseName?: string;
  email: string;
}

interface IDataNoSponsoredCoursesEvent extends IGenericCourseEvent {
  skillName?: string;
  institutionName?: string;
  courseProvider?: string;
  totalCourses: number;
}

interface IInterestedCourseEvent {
  action: MixpanelEventsEnum.INTERESTED_COURSE;
  data: IDataInterestedCourseEvent;
}

interface IClickProviderEvent {
  action: MixpanelEventsEnum.CLICK_PROVIDER;
  data: IDataGenericCourseEvent;
}

interface INoSponsoredCoursesEvent {
  action: MixpanelEventsEnum.NO_SPONSORED_COURSES;
  data: IDataNoSponsoredCoursesEvent;
}
// #endregion

// #region GENERAL EVENTS
interface IApplyFilterEventData extends IGenericPropsForEvents {
  filterName: string;
  filterValue: string;
  filterValueId: string;
}

interface IApplyFilterEvent {
  action: MixpanelEventsEnum.APPLY_FILTER;
  data: IApplyFilterEventData;
}
interface ISignUpEvent {
  action: MixpanelEventsEnum.SIGN_UP;
  data: IGenericPropsForEvents;
}

interface ILogInEvent {
  action: MixpanelEventsEnum.LOG_IN;
  data: IGenericPropsForEvents;
}

interface IResetPasswordEvent {
  action: MixpanelEventsEnum.RESET_PASSWORD;
  data: IGenericPropsForEvents;
}

interface IForgotPasswordEvent {
  action: MixpanelEventsEnum.FORGOT_PASSWORD;
  data: IGenericPropsForEvents;
}

interface IClickHereSignUpCodeEvent {
  action: MixpanelEventsEnum.CLICK_HERE_SIGN_UP_CODE;
  data: IGenericPropsForEvents;
}

interface IVerifyCodeEvent {
  action: MixpanelEventsEnum.VERIFY_CODE;
  data: IGenericPropsForEvents;
}

interface IPrivacyPolicyModalOpenEvent {
  action: MixpanelEventsEnum.PRIVACY_POLICY_MODAL_OPEN;
  data: IGenericPropsForEvents;
}

interface IDeclinePrivacyPolicyEvent {
  action: MixpanelEventsEnum.DECLINE_PRIVACY_POLICY;
  data: IGenericPropsForEvents;
}

interface IAcceptPrivacyPolicyEvent {
  action: MixpanelEventsEnum.ACCEPT_PRIVACY_POLICY;
  data: IGenericPropsForEvents;
}
// #endregion

// #region WIZARD EVENTS

interface ICVSkillsDetectedEventData extends IGenericPropsForEvents {
  skillsDetectedCount: number;
}
interface ICVSkillsDetectedEvent {
  action: MixpanelEventsEnum.CV_SKILLS_DETECTED;
  data: ICVSkillsDetectedEventData;
}

interface IWizardBackEventData extends IGenericPropsForEvents {
  fromStep: string;
  toStep: string;
}
interface IWizardBackEvent {
  action: MixpanelEventsEnum.WIZARD_BACK;
  data: IWizardBackEventData;
}
interface IWizardStartedEvent {
  action: MixpanelEventsEnum.WIZARD_STARTED;
  data: IGenericPropsForEvents;
}
interface IDataCompletedPersonalInformationStepEvent extends IGenericPropsForEvents {
  userType: string;
  majorsNumber: number;
  hobbiesNumber: number;
}

interface ICompletedPersonalInformationStepEvent {
  action: MixpanelEventsEnum.COMPLETED_PERSONAL_INFORMATION_STEP;
  data: IDataCompletedPersonalInformationStepEvent;
}

interface IDataCompletedOccupationsPreferencesStepEvent extends IGenericPropsForEvents {
  occupationsNumber: number;
}

interface ICompletedOccupationsPreferencesStepEvent {
  action: MixpanelEventsEnum.COMPLETED_OCCUPATIONS_PREFERENCES_STEP;
  data: IDataCompletedOccupationsPreferencesStepEvent;
}

interface IDataCompletedSkillsStepEvent extends IGenericPropsForEvents {
  skillsAdded: number;
  numberOfSpecialized: number;
  numberOfHuman: number;
}

interface ICompletedSkillsStepEvent {
  action: MixpanelEventsEnum.COMPLETED_SKILLS_STEP;
  data: IDataCompletedSkillsStepEvent;
}

interface IUploadCVEvent {
  action: MixpanelEventsEnum.UPLOAD_CV;
  data: IGenericPropsForEvents;
}

interface IReplaceCVEvent {
  action: MixpanelEventsEnum.REPLACE_CV;
  data: IGenericPropsForEvents;
}

interface IWizardCompletedEvent {
  action: MixpanelEventsEnum.WIZARD_COMPLETED;
  data: IGenericPropsForEvents;
}
// #endregion

// #region MAJOR EVENTS
interface IGenericAddMajorEvent extends IGenericPropsForEvents {
  majorName: string;
}
interface IAddMajorEvent {
  action: MixpanelEventsEnum.ADD_MAJOR;
  data: IGenericAddMajorEvent;
}

interface IDeleteMajorEvent {
  action: MixpanelEventsEnum.DELETE_MAJOR;
  data: IGenericAddMajorEvent;
}
// #endregion

// #region PAGES EVENTS
interface IHelpUsImproveEvent {
  action: MixpanelEventsEnum.HELP_US_IMPROVE;
  data: IGenericPropsForEvents;
}

interface IViewNotificationsEvent {
  action: MixpanelEventsEnum.VIEW_NOTIFICATIONS;
  data: IGenericPropsForEvents;
}

interface IClearNotificationsEvent {
  action: MixpanelEventsEnum.CLEAR_NOTIFICATIONS;
  data: IGenericPropsForEvents;
}

interface IProfilePopoverEvent {
  action: MixpanelEventsEnum.PROFILE_POPOVER;
  data: IGenericPropsForEvents;
}

interface IGoToProfileEvent {
  action: MixpanelEventsEnum.GO_TO_PROFILE;
  data: IGenericPropsForEvents;
}

interface IChangePasswordEvent {
  action: MixpanelEventsEnum.CHANGE_PASSWORD;
  data: IGenericPropsForEvents;
}
interface ILogoutEvent {
  action: MixpanelEventsEnum.LOGOUT;
  data: IGenericPropsForEvents;
}

interface IEditPersonalInfoEvent {
  action: MixpanelEventsEnum.EDIT_PERSONAL_INFO;
  data: IGenericPropsForEvents;
}

interface IUpdatePersonalInfoEvent {
  action: MixpanelEventsEnum.UPDATE_PERSONAL_INFO;
  data: IGenericPropsForEvents;
}

interface IProfileUpdatedSkillsEvent {
  action: MixpanelEventsEnum.PROFILE_UPDATED_SKILLS;
  data: IGenericPropsForEvents;
}

interface IProfileUpdatedPreferencesEvent {
  action: MixpanelEventsEnum.PROFILE_UPDATED_PREFERENCES;
  data: IGenericPropsForEvents;
}

interface IViewMoreEventData extends IGenericPropsForEvents {
  name: string;
}
interface IViewMoreEvent {
  action: MixpanelEventsEnum.VIEW_MORE;
  data: IViewMoreEventData;
}

interface ISkillTrackerFilterEventData extends IGenericPropsForEvents {
  occupation?: string;
  skillType?: string;
}

interface ISkillTrackerFilterEvent {
  action: MixpanelEventsEnum.SKILL_TRACKER_FILTER;
  data: ISkillTrackerFilterEventData;
}

interface IOptionsKanabnSkillEvent {
  action: MixpanelEventsEnum.OPTIONS_KANBAN_SKILL;
  data: IGenericPropsForEvents;
}
interface IExpandProficiencyLevelsEvent {
  action: MixpanelEventsEnum.EXPAND_PROFICIENCY_LEVELS;
  data: IGenericPropsForEvents;
}

interface IDataMoveRouletteEvent extends IGenericPropsForEvents {
  name: string;
}
interface IMoveRouletteEvent {
  action: MixpanelEventsEnum.MOVE_ROULETTE;
  data: IDataMoveRouletteEvent;
}

interface ITabEventData extends IGenericPropsForEvents {
  tabName: string;
}

interface ITabEvent {
  action: MixpanelEventsEnum.TAB_EVENT;
  data: ITabEventData;
}

interface IFAQQuestionEventData extends IGenericPropsForEvents {
  questionNumber: string;
}

interface IFAQQuestionEvent {
  action: MixpanelEventsEnum.FAQ_QUESTION;
  data: IFAQQuestionEventData;
}

interface IViewPrivacyPolicyEvent {
  action: MixpanelEventsEnum.VIEW_PRIVACY_POLICY;
  data: IGenericPropsForEvents;
}

interface IViewTermsOfServiceEvent {
  action: MixpanelEventsEnum.VIEW_TERMS_OF_SERVICE;
  data: IGenericPropsForEvents;
}
// #endregion

// #region SCREEN TIME
interface IDataScreenTimeEvent extends IGenericPropsForEvents {
  timeScreen: string;
}

interface IScreenTimeEvent {
  action: MixpanelEventsEnum.SCREEN_TIME;
  data: IDataScreenTimeEvent;
}
// #endregion

// #region ADVISOR
interface IMajorFilterSuggestionsEvent {
  action: MixpanelEventsEnum.MAJOR_FILTER_SUGGESTIONS;
  data: IGenericOccupationEvent;
}

interface ISelectSkillInsightsScreenEvent {
  action: MixpanelEventsEnum.SELECT_SKILL_INSIGHTS_SCREEN;
  data: IGenericOccupationEvent;
}

interface IExploreOccupationOverviewModalEvent {
  action: MixpanelEventsEnum.EXPLORE_OCCUPATION_OVERVIEW_MODAL;
  data: IGenericOccupationEvent;
}

interface ICardTopSkillScrollEvent {
  action: MixpanelEventsEnum.CARD_TOP_SKILL_SCROLL;
  data: IGenericPropsForEvents;
}

interface IDataSearchByStudentNameEvent extends IGenericPropsForEvents {
  studentName: string;
}

interface ISearchByStudentNameEvent {
  action: MixpanelEventsEnum.SEARCH_BY_STUDENT_NAME;
  data: IDataSearchByStudentNameEvent;
}

interface IAdvisorProfilePopoverEvent {
  action: MixpanelEventsEnum.ADVISOR_PROFILE_POPOVER;
  data: IGenericPropsForEvents;
}

interface IExportStudentOverviewCSVEventData extends IGenericPropsForEvents {
  facultyId?: string;
  userType?: string;
  academicProgramIds?: string;
}

interface IExportStudentOverviewCSVEvent {
  action: MixpanelEventsEnum.EXPORT_STUDENT_OVERVIEW_CSV;
  data: IExportStudentOverviewCSVEventData;
}
// #endregion

// #region HOBBY

interface IGenericHobbyEvent extends IGenericPropsForEvents {
  hobbyName: string;
  hobbyId: string;
}
interface IAddHobbyEvent {
  action: MixpanelEventsEnum.ADD_HOBBY;
  data: IGenericHobbyEvent;
}
// #endregion

// #region IKIGAI
interface IIkigaiHome {
  action: MixpanelEventsEnum.IKIGAI_HOME;
  data: IGenericPropsForEvents;
}

interface IIkigaiPassion {
  action: MixpanelEventsEnum.IKIGAI_STEP_PASSION;
  data: IGenericPropsForEvents;
}

interface IIkigaiMission {
  action: MixpanelEventsEnum.IKIGAI_STEP_MISSION;
  data: IGenericPropsForEvents;
}

interface IIkigaiProfession {
  action: MixpanelEventsEnum.IKIGAI_STEP_PROFESSION;
  data: IGenericPropsForEvents;
}

interface IIkigaiVocation {
  action: MixpanelEventsEnum.IKIGAI_STEP_VOCATION;
  data: IGenericPropsForEvents;
}

interface IIkigaiRecommendationsEvent extends IGenericPropsForEvents {
  recommendedJobs: string[];
}

interface IIkigaiRecommendations {
  action: MixpanelEventsEnum.IKIGAI_RECOMMENDATIONS;
  data: IIkigaiRecommendationsEvent;
}
// #endregion

// #region NOTIFICATIONS EVENTS
interface IAdvisorNotificationEmailData extends IGenericPropsForEvents {
  emailAdvisor: string;
}

export interface IAdvisorNotificationScreenEvent {
  action: MixpanelEventsEnum.ADVISOR_NOTIFICATION;
  data: IAdvisorNotificationEmailData;
}
// #endregion

// #region JOB POSTING RECOMMENDATIONS EVENTS

interface IViewRelevantSkillsEventData extends IGenericPropsForEvents {
  jobTitleName: string;
}

export interface IViewRelevantSkillsEvent {
  action: MixpanelEventsEnum.VIEW_RELEVANT_SKILLS;
  data: IViewRelevantSkillsEventData;
}

interface IViewJobPostingEventData extends IGenericPropsForEvents {
  jobTitleName: string;
}

export interface IViewJobPostingEvent {
  action: MixpanelEventsEnum.VIEW_JOB_POSTING;
  data: IViewJobPostingEventData;
}

// #endregion

// #region SAVED COURSES EVENTS

type SelectCollectionType = 'new collection' | 'existing collection' | 'all courses';

interface IBookmarkClickEventData extends IGenericPropsForEvents {
  courseName: string;
  savedCourseId: string;
}

interface IBookmarkClickEvent {
  action: MixpanelEventsEnum.BOOKMARK_CLICK;
  data: IBookmarkClickEventData;
}

interface ISelectCollectionEventData extends IGenericPropsForEvents {
  selectionType: SelectCollectionType;
  collectionName?: string;
  collectionId?: string;
}

interface ISelectCollectionEvent {
  action: MixpanelEventsEnum.SELECT_COLLECTION;
  data: ISelectCollectionEventData;
}

interface ICreateCollectionEventData extends IGenericPropsForEvents {
  collectionName: string;
}

interface ICreateCollectionEvent {
  action: MixpanelEventsEnum.CREATE_COLLECTION;
  data: ICreateCollectionEventData;
}

interface IDeleteCollectionEventData extends IGenericPropsForEvents {
  collectionId: string;
  collectionName: string;
  courseCount: number;
}

interface IDeleteCollectionEvent {
  action: MixpanelEventsEnum.DELETE_COLLECTION;
  data: IDeleteCollectionEventData;
}

interface IModifyCollectionNameEventData extends IGenericPropsForEvents {
  collectionId: string;
  oldName: string;
  newName: string;
}

interface IModifyCollectionNameEvent {
  action: MixpanelEventsEnum.MODIFY_COLLECTION_NAME;
  data: IModifyCollectionNameEventData;
}

interface IDeleteCourseFromCollectionEventData extends IGenericPropsForEvents {
  courseName: string;
  savedCourseId: string;
}

interface IDeleteCourseFromCollectionEvent {
  action: MixpanelEventsEnum.DELETE_COURSE_FROM_COLLECTION;
  data: IDeleteCourseFromCollectionEventData;
}

type SavedCoursesSourceType = 'All saved courses' | 'Collection';

type CourseSavedDestinationType = 'New collection' | 'Existing collection' | 'All saved courses';

interface IEmptyStateAddCoursesTappedEventData extends IGenericPropsForEvents {
  source: SavedCoursesSourceType;
}

interface IEmptyStateAddCoursesTappedEvent {
  action: MixpanelEventsEnum.EMPTY_STATE_ADD_COURSES_TAPPED;
  data: IEmptyStateAddCoursesTappedEventData;
}

interface ISaveCourseIconTappedEventData extends IGenericPropsForEvents {
  courseName: string;
  courseProvider: string;
}

interface ISaveCourseIconTappedEvent {
  action: MixpanelEventsEnum.SAVE_COURSE_ICON_TAPPED;
  data: ISaveCourseIconTappedEventData;
}

interface ICourseSavedEventData extends IGenericPropsForEvents {
  courseName: string;
  courseProvider: string;
  destination: CourseSavedDestinationType;
}

interface ICourseSavedEvent {
  action: MixpanelEventsEnum.COURSE_SAVED;
  data: ICourseSavedEventData;
}

interface IToastCTACoursesTappedEventData extends IGenericPropsForEvents {
  courseName: string;
}

interface IToastCTACoursesTappedEvent {
  action: MixpanelEventsEnum.TOAST_CTA_COURSES_TAPPED;
  data: IToastCTACoursesTappedEventData;
}

interface IRemoveSavedCourseEventData extends IGenericPropsForEvents {
  courseName: string;
  courseProvider: string;
  source: SavedCoursesSourceType;
}

interface IRemoveSavedCourseEvent {
  action: MixpanelEventsEnum.REMOVE_SAVED_COURSE;
  data: IRemoveSavedCourseEventData;
}

// #endregion

// #region ERROR EVENTS

interface ILoginErrorEventData extends IGenericPropsForEvents {
  errorType: string;
  authMethod: string;
}

interface ILoginErrorEvent {
  action: MixpanelEventsEnum.LOGIN_ERROR;
  data: ILoginErrorEventData;
}

interface ISignupErrorEventData extends IGenericPropsForEvents {
  errorType: string;
}

interface ISignupErrorEvent {
  action: MixpanelEventsEnum.SIGNUP_ERROR;
  data: ISignupErrorEventData;
}

interface ILoginAttemptEvent {
  action: MixpanelEventsEnum.LOGIN_ATTEMPT;
  data: ILoginAttemptEventData;
}

// #endregion

// #region LEARNING RESOURCE ROI EVENTS

interface ILearningResourceROIEventData extends IGenericPropsForEvents {
  occupationsCount: number;
  maxImprovement: number;
}

interface IViewLearningResourceROISectionEvent {
  action: MixpanelEventsEnum.VIEW_LEARNING_RESOURCE_ROI_SECTION;
  data: ILearningResourceROIEventData;
}

interface IExpandLearningResourceROIEvent {
  action: MixpanelEventsEnum.EXPAND_LEARNING_RESOURCE_ROI;
  data: ILearningResourceROIEventData;
}

interface ICollapseLearningResourceROIEvent {
  action: MixpanelEventsEnum.COLLAPSE_LEARNING_RESOURCE_ROI;
  data: ILearningResourceROIEventData;
}

interface IViewLearningResourceROICardEventData extends IGenericPropsForEvents {
  occupationName: string;
  improvement: IROIResult;
  currentMatch: number;
  cardPosition: number;
}

interface IViewLearningResourceROICardEvent {
  action: MixpanelEventsEnum.VIEW_LEARNING_RESOURCE_ROI_CARD;
  data: IViewLearningResourceROICardEventData;
}

// #region AUTH EVENTS

interface ILoginAttemptEventData extends IGenericPropsForEvents {
  provider: string;
}

interface ISSOInitiatedEvent {
  action: MixpanelEventsEnum.SSO_INITIATED;
  data: ILoginAttemptEventData;
}

// #endregion

// #region PLAR EXPERIENCE EVENTS
interface IAddExperienceEventData extends IGenericPropsForEvents {
  experienceType: string;
  educationType: string | null;
  experienceName: string;
}

interface IAddExperienceEvent {
  action: MixpanelEventsEnum.ADD_EXPERIECNCE;
  data: IAddExperienceEventData;
}

interface IOpenEditExperienceEventData extends IGenericPropsForEvents {
  experienceType: string;
  educationType: string;
  jobTitleId: string;
  jobTitleName: string;
}

interface IDeleteExperienceEventData extends IGenericPropsForEvents {
  experienceType: string;
  jobTitleId: string;
  jobTitleName: string;
}

interface IOpenAddExperienceEvent {
  action: MixpanelEventsEnum.OPEN_ADD_EXPERIENCE;
  data: IGenericPropsForEvents;
}

interface IOpenEditExperienceEvent {
  action: MixpanelEventsEnum.OPEN_EDIT_EXPERIENCE;
  data: IOpenEditExperienceEventData;
}

interface IDeleteExperienceEvent {
  action: MixpanelEventsEnum.DELETE_EXPERIENCE;
  data: IDeleteExperienceEventData;
}

interface IEditExperienceEventData extends IGenericPropsForEvents {
  originalExperienceType: string;
  originalJobTitleId?: string;
  originalJobTitleName?: string;
  experienceType: string;
  educationType?: string;
  jobTitleId?: string;
  experienceName: string;
}

interface IEditExperienceEvent {
  action: MixpanelEventsEnum.EDIT_EXPERIENCE;
  data: IEditExperienceEventData;
}

interface IExtractExperienceSkillsEventData extends IGenericPropsForEvents {
  experienceType: string;
  skillsCount: number;
  addedSkillsCount: number;
  isEditMode: boolean;
}

interface IExtractExperienceSkillsEvent {
  action: MixpanelEventsEnum.EXTRACT_EXPERIENCE_SKILLS;
  data: IExtractExperienceSkillsEventData;
}

interface IRequestContactLPPLAREventData extends IGenericPropsForEvents {
  pathwayId: string;
}

interface IRequestContactLPPLAREvent {
  action: MixpanelEventsEnum.REQUEST_CONTACT_LP_PLAR;
  data: IRequestContactLPPLAREventData;
}

// #endregion

interface IViewJobOutlookSalaryEventData extends IGenericPropsForEvents {
  jobTitleId: string;
  marketInsightsInterestEmptyState: boolean;
}

interface IViewJobOutlookSalaryEvent {
  action: MixpanelEventsEnum.VIEW_JOB_OUTLOOK_SALARY;
  data: IViewJobOutlookSalaryEventData;
}

interface IViewJobOutlookSalaryEmptyEvent {
  action: MixpanelEventsEnum.VIEW_JOB_OUTLOOK_SALARY_EMPTY;
  data: IViewJobOutlookSalaryEventData;
}

interface IClickJobOutlookInterestEventData extends IGenericPropsForEvents {
  jobTitleId: string;
  marketInsightsInterestEmptyState: boolean;
}

interface IClickJobOutlookAiImpactInterestEvent {
  action: MixpanelEventsEnum.CLICK_JOB_OUTLOOK_AI_IMPACT_INTEREST;
  data: IClickJobOutlookInterestEventData;
}

interface IClickJobOutlookGlobalDemandInterestEvent {
  action: MixpanelEventsEnum.CLICK_JOB_OUTLOOK_GLOBAL_DEMAND_INTEREST;
  data: IClickJobOutlookInterestEventData;
}

interface IClickJobPostingRecommendationsOutlookEventData extends IGenericPropsForEvents {
  jobTitleId: string;
}

interface IClickJobPostingRecommendationsOutlookEvent {
  action: MixpanelEventsEnum.CLICK_JOBPOSTING_RECOMMENDATIONS_OUTLOOK;
  data: IClickJobPostingRecommendationsOutlookEventData;
}

interface IViewSalaryTrendsEventData extends IGenericPropsForEvents {
  occupation: string;
  country: string;
  yearRange?: string;
}

interface IViewSalaryTrendsEvent {
  action: MixpanelEventsEnum.VIEW_SALARY_TRENDS;
  data: IViewSalaryTrendsEventData;
}

interface IViewSalaryTrendsEmptyEvent {
  action: MixpanelEventsEnum.VIEW_SALARY_TRENDS_EMPTY;
  data: IViewSalaryTrendsEventData;
}

// #region ALUMNI INSIGHTS EVENTS

interface IAlumniInsightsBlueBoxViewedEvent {
  action: MixpanelEventsEnum.ALUMNI_INSIGHTS_BLUE_BOX_VIEWED;
  data: IGenericPropsForEvents;
}

interface IAlumniInsightsBlueBoxClickedEvent {
  action: MixpanelEventsEnum.ALUMNI_INSIGHTS_BLUE_BOX_CLICKED;
  data: IGenericPropsForEvents;
}

interface IAlumniInsightsModalOpenedEvent {
  action: MixpanelEventsEnum.ALUMNI_INSIGHTS_MODAL_OPENED;
  data: IGenericPropsForEvents;
}

interface IAlumniInsightsModalClosedEvent {
  action: MixpanelEventsEnum.ALUMNI_INSIGHTS_MODAL_CLOSED;
  data: IGenericPropsForEvents;
}

interface IAlumniInsightsInterestConfirmedEvent {
  action: MixpanelEventsEnum.ALUMNI_INSIGHTS_INTEREST_CONFIRMED;
  data: IGenericPropsForEvents;
}

interface IAlumniInsightsRequestSuccessEvent {
  action: MixpanelEventsEnum.ALUMNI_INSIGHTS_REQUEST_SUCCESS;
  data: IGenericPropsForEvents;
}

interface IAlumniInsightsRequestFailedEvent {
  action: MixpanelEventsEnum.ALUMNI_INSIGHTS_REQUEST_FAILED;
  data: IGenericPropsForEvents;
}

// #endregion

// #region CURRICULAR ANALYTICS EVENTS
interface ICustomizeOccupationListButtonClickedEvent {
  action: MixpanelEventsEnum.CUSTOMIZE_OCCUPATION_LIST_BUTTON_CLICKED;
  data: IGenericPropsForEvents;
}

interface ICurricularAnalyticsModalOpenedEvent {
  action: MixpanelEventsEnum.CURRICULAR_ANALYTICS_MODAL_OPENED;
  data: IGenericPropsForEvents;
}

interface ICurricularAnalyticsModalClosedEvent {
  action: MixpanelEventsEnum.CURRICULAR_ANALYTICS_MODAL_CLOSED;
  data: IGenericPropsForEvents;
}

interface ICurricularAnalyticsInterestConfirmedEvent {
  action: MixpanelEventsEnum.CURRICULAR_ANALYTICS_INTEREST_CONFIRMED;
  data: IGenericPropsForEvents;
}

interface ICurricularAnalyticsRequestSuccessEvent {
  action: MixpanelEventsEnum.CURRICULAR_ANALYTICS_REQUEST_SUCCESS;
  data: IGenericPropsForEvents;
}

interface ICurricularAnalyticsRequestFailedEvent {
  action: MixpanelEventsEnum.CURRICULAR_ANALYTICS_REQUEST_FAILED;
  data: IGenericPropsForEvents;
}
// #region CAREER GOALS EVENTS
interface IEnterOccupationComparisonEventData extends IGenericPropsForEvents {
  occupationName: string;
  totalOccupations: number;
}

interface IEnterOccupationComparisonEvent {
  action: MixpanelEventsEnum.ENTER_OCCUPATION_COMPARISON;
  data: IEnterOccupationComparisonEventData;
}

interface ISelectOccupationComparisonFilterEventData extends IGenericPropsForEvents {
  filterName: string;
}

interface ISelectOccupationComparisonFilterEvent {
  action: MixpanelEventsEnum.SELECT_OCCUPATION_COMPARISON_FILTER;
  data: ISelectOccupationComparisonFilterEventData;
}

interface IToggleOccupationInComparisonEventData extends IGenericPropsForEvents {
  occupationName: string;
  occupationId: string;
  event: string;
}

interface IToggleOccupationInComparisonEvent {
  action: MixpanelEventsEnum.TOGGLE_OCCUPATION_IN_COMPARISON;
  data: IToggleOccupationInComparisonEventData;
}

interface IClickDesignPathEvent {
  action: MixpanelEventsEnum.CLICK_DESIGN_PATH;
  data: IGenericPropsForEvents;
}

interface IPathCreationStepCompletedEventData extends IGenericPropsForEvents {
  stepNumber: number;
}

interface IPathCreationStepCompletedEvent {
  action: MixpanelEventsEnum.OPENED_PATH_CREATION_STEP;
  data: IPathCreationStepCompletedEventData;
}

interface IFinishedPathCreationEventData extends IGenericPropsForEvents {
  occupationName: string;
}

interface IFinishedPathCreationEvent {
  action: MixpanelEventsEnum.FINISHED_PATH_CREATION;
  data: IFinishedPathCreationEventData;
}

interface IOccupationSuggestedTappedEventData extends IGenericPropsForEvents {
  occupationName: string;
  suggestedBy: string;
}

interface IOccupationSuggestedTappedEvent {
  action: MixpanelEventsEnum.OCCUPATION_SUGGESTED_TAPPED;
  data: IOccupationSuggestedTappedEventData;
}

interface IClickCareerFinderQuizEvent {
  action: MixpanelEventsEnum.CLICK_CAREER_FINDER_QUIZ;
  data: IGenericPropsForEvents;
}

interface IAddCareerFieldCtaEventData extends IGenericPropsForEvents {
  source: string;
}

interface IAddCareerFieldCtaEvent {
  action: MixpanelEventsEnum.ADD_CAREER_FIELD_CTA;
  data: IAddCareerFieldCtaEventData;
}

interface IOccupationModalLimitViewedEventData extends IGenericPropsForEvents {
  occupationName: string;
}

interface IOccupationModalLimitViewedEvent {
  action: MixpanelEventsEnum.OCCUPATION_MODAL_LIMIT_VIEWED;
  data: IOccupationModalLimitViewedEventData;
}

interface IOccupationReplacedEventData extends IGenericPropsForEvents {
  newOccupation: string;
  replacedOccupation: string;
}

interface IOccupationReplacedEvent {
  action: MixpanelEventsEnum.OCCUPATION_REPLACED;
  data: IOccupationReplacedEventData;
}

// #endregion

export type IMixpanelEvents =
  | IAddSkillEvent
  | ICompletedPersonalInformationStepEvent
  | IAddMajorEvent
  | ICompletedOccupationsPreferencesStepEvent
  | IDeleteMajorEvent
  | ICompletedSkillsStepEvent
  | IUploadCVEvent
  | IReplaceCVEvent
  | IHelpUsImproveEvent
  | IViewNotificationsEvent
  | IClearNotificationsEvent
  | IProfilePopoverEvent
  | IGoToProfileEvent
  | IChangePasswordEvent
  | ILogoutEvent
  | IEditPersonalInfoEvent
  | IUpdatePersonalInfoEvent
  | IProfileUpdatedSkillsEvent
  | IProfileUpdatedPreferencesEvent
  | IDeleteSkillEvent
  | IModifySkillEvent
  | IExploreSkillModalEvent
  | IExploreSkillScreenEvent
  | IViewMoreEvent
  | ISkillTrackerFilterEvent
  | IOptionsKanabnSkillEvent
  | IExpandProficiencyLevelsEvent
  | IMoveRouletteEvent
  | ITabEvent
  | IFAQQuestionEvent
  | IViewPrivacyPolicyEvent
  | IViewTermsOfServiceEvent
  | IAddOccupationEvent
  | IExploreOccupationModalEvent
  | IClickCourseEvent
  | ISignUpEvent
  | ILogInEvent
  | IResetPasswordEvent
  | IForgotPasswordEvent
  | IClickHereSignUpCodeEvent
  | IVerifyCodeEvent
  | IPrivacyPolicyModalOpenEvent
  | IDeclinePrivacyPolicyEvent
  | IAcceptPrivacyPolicyEvent
  | IBrowseMoreCoursesEvent
  | IFilterCourseProvider
  | IDeleteOccupationEvent
  | IExploreOccupationScreen
  | IScreenTimeEvent
  | IWizardCompletedEvent
  | IMajorFilterSuggestionsEvent
  | ISelectSkillInsightsScreenEvent
  | IExploreOccupationOverviewModalEvent
  | ICardTopSkillScrollEvent
  | ISearchByStudentNameEvent
  | IAdvisorProfilePopoverEvent
  | IClickProviderEvent
  | INoSponsoredCoursesEvent
  | IAddHobbyEvent
  | IIkigaiHome
  | IIkigaiPassion
  | IIkigaiMission
  | IIkigaiProfession
  | IIkigaiVocation
  | IIkigaiRecommendations
  | ILearningResourcesInterestedEvent
  | ILearningResourcesNotInterestedEvent
  | IInterestedCourseEvent
  | IAdvisorNotificationScreenEvent
  | IViewRelevantSkillsEvent
  | IViewJobPostingEvent
  | IApplyFilterEvent
  | IExpandAccordionProficiencyLevelsEvent
  | ISelectProficiencyLevelEvent
  | IProficiencyTabSelectedEvent
  | IViewLearningPathEvent
  | IViewLearningPathEvent
  | IExportStudentOverviewCSVEvent
  | IBookmarkClickEvent
  | ISelectCollectionEvent
  | ICreateCollectionEvent
  | IDeleteCollectionEvent
  | IModifyCollectionNameEvent
  | IDeleteCourseFromCollectionEvent
  | IEmptyStateAddCoursesTappedEvent
  | ISaveCourseIconTappedEvent
  | ICourseSavedEvent
  | IToastCTACoursesTappedEvent
  | IRemoveSavedCourseEvent
  | IViewLearningResourceROISectionEvent
  | IExpandLearningResourceROIEvent
  | ICollapseLearningResourceROIEvent
  | IViewLearningResourceROICardEvent
  | IAddExperienceEvent
  | IEditExperienceEvent
  | IDeleteExperienceEvent
  | IOpenAddExperienceEvent
  | IOpenEditExperienceEvent
  | IExtractExperienceSkillsEvent
  | IRequestContactLPPLAREvent
  | IViewSalaryTrendsEvent
  | IViewSalaryTrendsEmptyEvent
  | IViewJobOutlookSalaryEvent
  | IViewJobOutlookSalaryEmptyEvent
  | IClickJobOutlookAiImpactInterestEvent
  | IClickJobOutlookGlobalDemandInterestEvent
  | IClickJobPostingRecommendationsOutlookEvent
  | ISignupErrorEvent
  | ILoginErrorEvent
  | ISSOInitiatedEvent
  | ILoginAttemptEvent
  | IWizardStartedEvent
  | IWizardBackEvent
  | ICVSkillsDetectedEvent
  | IAlumniInsightsBlueBoxViewedEvent
  | IAlumniInsightsBlueBoxClickedEvent
  | IAlumniInsightsModalOpenedEvent
  | IAlumniInsightsModalClosedEvent
  | IAlumniInsightsInterestConfirmedEvent
  | IAlumniInsightsRequestSuccessEvent
  | IAlumniInsightsRequestFailedEvent
  | ICustomizeOccupationListButtonClickedEvent
  | ICurricularAnalyticsModalOpenedEvent
  | ICurricularAnalyticsModalClosedEvent
  | ICurricularAnalyticsInterestConfirmedEvent
  | ICurricularAnalyticsRequestSuccessEvent
  | ICurricularAnalyticsRequestFailedEvent
  | IEnterOccupationComparisonEvent
  | ISelectOccupationComparisonFilterEvent
  | IToggleOccupationInComparisonEvent
  | IClickDesignPathEvent
  | IPathCreationStepCompletedEvent
  | IFinishedPathCreationEvent
  | IOccupationSuggestedTappedEvent
  | IClickCareerFinderQuizEvent
  | IAddCareerFieldCtaEvent
  | IOccupationModalLimitViewedEvent
  | IOccupationReplacedEvent
  | ILearningPathSearchPerformedEvent
  | ISearchResultItemTappedEvent
  | ILPCareerMatchAccordionExpandedEvent
  | IOccupationMatchDetailExpandedEvent
  | IAddToMyPathsEvent
  | IViewAllSkillsTappedEvent;
